var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('shop',{attrs:{"include-categories":false}},[_c('div',{staticClass:"text-center"},[_c('h1',[_vm._v("Business order details will be here")])])])}
var staticRenderFns = []

export { render, staticRenderFns }